import React, { FC, ReactElement } from 'react';
import './SearchField.scss';
import { SearchContent as ISearchField } from './Interfaces/SearchField';
import { Button, SearchBar } from 'mvw-component-library';
import {
  DESTINATION_REACT_APP_BASE_URL,
  SEARCH_API_URL,
  SEARCH_API_URL_USER,
  EMULATED_SEARCH_API_URL,
  SEARCH_ID,
} from '../../Utility/constants';
import { getAccessToken } from '../../Features/DestinationMainNav/DestinationMainNavService';

interface IProps {
  SearchContent?: ISearchField | undefined;
  searchIcon: string;
}

const SearchField: FC<IProps> = ({ SearchContent, searchIcon }: IProps): ReactElement => {
  const placeHolderLabel = SearchContent?.searchBarPlaceholderText;
  const btnLabel: string = SearchContent?.viewAllButton ? SearchContent?.viewAllButton.split('|')[0] : '';
  const btnLink: string = SearchContent?.viewAllButton ? SearchContent?.viewAllButton.split('|')[1] : '';
  let userInfo: any = document.getElementById('is-emulated')?.dataset.value;
  userInfo = userInfo ? JSON.parse(userInfo) : {};
  const ACCESS_TOKEN = userInfo === 1 ? getUserObjectValue() : getAccessToken();
  const searchUrl =
    userInfo === 1
      ? process.env.REACT_APP_EXP_API_BASE_URL + EMULATED_SEARCH_API_URL
      : ACCESS_TOKEN && ACCESS_TOKEN !== ''
      ? process.env.REACT_APP_EXP_API_BASE_URL + SEARCH_API_URL_USER
      : process.env.REACT_APP_EXP_API_BASE_URL + SEARCH_API_URL;

  let API_KEY = process.env.REACT_APP_EXP_API_MASHERY_KEY;
  const urlPrefix = window.location.href.includes('localhost') ? '/#/searchResults/' : DESTINATION_REACT_APP_BASE_URL;

  return (
    <div className="search-by-container rc-row" aria-label={placeHolderLabel}>
      <div className="rc-col-lg-9 rc-col-md-12">
        <SearchBar
          placeholderText={placeHolderLabel}
          searchIdAttr={SEARCH_ID}
          searchIcon={searchIcon}
          serviceUrl={searchUrl}
          apiKey={API_KEY}
          urlPreFix={urlPrefix}
          defaultSearchTerm={''}
          accessToken={ACCESS_TOKEN}
        />
      </div>
      <div className="rc-col-1 search-or">OR</div>
      <div className="rc-col-2 search-button">
        <Button btnLink={btnLink} label={btnLabel} primary size="large" />
      </div>
    </div>
  );
};

export default SearchField;
const getUserObjectValue = () => {
  const rootElement = document.getElementById('userObject');
  const dataUser = rootElement?.getAttribute('data-user');
  const parsedUserData = dataUser && JSON.parse(dataUser);
  let request: any = {
    memberId: parsedUserData?.ownerMemberId,
  };
  return request;
};
